import PropTypes from 'prop-types';
import cx from 'classnames';
import stylesModule from '../../../../summary-and-payment/styles.module.scss';
import ProductLink from '@app/components/common/product/ProductLink';
import { ItemGADetailsPropTypes } from '@app/components/pages/checkout/order-confirmation/declarations.proptypes';

const ItemsInOrderTableName = ({
  name,
  productDisplayUrl,
  itemGADetails,
  listName
}) => {
  const className = cx(
    'exclude-global mb-1 text-univers u-fs--16',
    stylesModule['text-print-md'],
    stylesModule['print-on-black'],
    { 'u-color--ExtraDarkGray': !productDisplayUrl }
  );
  return (
    <ProductLink
      link={productDisplayUrl}
      productClickDetails={itemGADetails}
      gaListName={listName}
      className={stylesModule['print-no-underline']}
    >
      <p className={className}>{name}</p>
    </ProductLink>
  );
};

ItemsInOrderTableName.propTypes = {
  name: PropTypes.string.isRequired,
  productDisplayUrl: PropTypes.string,
  itemGADetails: ItemGADetailsPropTypes,
  listName: PropTypes.string
};

export default ItemsInOrderTableName;
